<template>
	<div class="pik-widget pik-auth w-full text-12px overflow-hidden">
    <header class="flex flex-row justify-center bg-gray-001 p-12">
      <img src="https://cdn.atpoc.com/assets/production/pik/logo/pik-poc-kaplan-logo.png" style="width:200px;min-width:200px;max-width:200px;"/>
    </header>
    <div class="px-12 py-14 bg-white">
      <template v-if="isLoading">
        <section class="w-full h-full flex flex-row justify-center items-center">
          <LoadingSpinner></LoadingSpinner>
        </section>
      </template>
      <template v-else>
        <section class="flex flex-col gap-9">
          <div class="flex flex-row gap-3 font-medium text-gray-006">
            <button 
              class="hover:text-red"
              :class="{
                'text-red underline pointer-events-none': currView === 'login'
              }"
              type="button"
              @click="handleSetCurrView('login')"
            >Login</button>
            <a 
              class="hover:text-red" 
              :href="regUrl"
            >Create Account</a>
          </div>
          <div>
            <template v-if="isError">
              <section class="w-full h-full flex flex-row justify-center items-center">
                  <div 
                    class="flex flex-col gap-6 justify-between text-red"
                    :style="{
                      minHeight: minContentHeight 
                    }"
                  >
                    <div class="flex flex-col gap-4">
                      <h3 class="text-24px" v-html="errorTitle"></h3>
                      <p v-html="errorMessage"></p>
                    </div>
                    <div class="flex flex-col gap-3">
                      <div>
                        <div class="flex flex-col gap-3">
                          <button 
                            class="bg-black text-white rounded-default p-3"
                            type="button"
                            @click="handlTryAgainClick()"
                          >Try Again</button>
                        </div>
                      </div> 
                    </div>
                  </div>
              </section>
            </template>
            <template v-else>
              <div class="relative">
                <div 
                  v-if="currView === 'login'"
                  class="flex flex-col gap-6 justify-between"
                  :style="{
                    minHeight: minContentHeight 
                  }"
                >
                  <div class="flex flex-col gap-4">
                    <h3 class="text-24px">Welcome</h3>
                    <p>Use your existing email and<br />password to sign in.</p>
                  </div>
                  <form @submit.prevent="handleLoginSubmit()" class="flex flex-col gap-3">
                    <div>
                      <div 
                        v-if="loginView === 'email'"
                        class="flex flex-col gap-3"
                      >
                        <div>
                          <button 
                            class="text-gray-006 hover:text-red" 
                            type="button"
                            @click="handleSetCurrView('forgotpassword')"
                          ><p>Forgot password?</p></button>
                        </div>
                        <div>
                          <input 
                            v-model="loginEmail" 
                            ref="loginEmailEl"
                            class="p-3 bg-gray-001 rounded-default border-1 border-solid border-gray-003"
                            type="email" 
                            :placeholder="emailPlaceholder"
                            @keyup.enter="handleEmailSubmit()"
                            required
                          >
                        </div>
                        <button 
                          class="bg-black text-white rounded-default p-3"
                          type="button"
                          @click="handleEmailSubmit()"
                        >Continue</button>
                      </div>
                      <div 
                        v-if="loginView === 'password'"
                        class="flex flex-col gap-3"
                      >
                        <div>
                          <button 
                            class="text-gray-006 hover:text-red" 
                            type="button"
                            @click="handleSetCurrView('forgotpassword')"
                          ><p>Forgot password?</p></button>
                        </div>
                        <div class="relative">
                          <input 
                            v-if="!showPassword"
                            v-model="loginPassword"
                            ref="loginPasswordEl"
                            class="p-3 bg-gray-001 rounded-default border-1 border-solid border-gray-003"
                            type="password" 
                            placeholder="Password"
                            @keyup.enter="handleLoginSubmit()"
                            required
                          >
                          <input 
                            v-else
                            v-model="loginPassword"
                            ref="loginPasswordEl"
                            class="p-3 bg-gray-001 rounded-default border-1 border-solid border-gray-003"
                            type="text" 
                            placeholder="Password"
                            @keyup.enter="handleLoginSubmit()"
                            required
                          >
                          <div class="absolute top-1/2 right-0 transform -translate-y-1/2 -translate-x-3">
                            <button
                              v-if="!showPassword"
                              type="button"
                              @click="handleSetShowPassword(true)"
                            ><span>show</span></button>
                            <button 
                              v-else
                              type="button"
                              @click="handleSetShowPassword(false)"
                            ><span>hide</span></button>
                          </div>
                        </div>
                        <button 
                          class="bg-black text-white rounded-default p-3"
                          type="submit"
                        >Continue</button>
                      </div>
                    </div> 
                    <div class="flex flex-row gap-1 justify-center">
                      <button
                        :class="{
                          'bg-red pointer-events-none': loginView === 'email',
                          'bg-gray-004 cursor-pointer': loginView === 'password'
                        }"
                        style="width:10px; height:3px; border-radius: 1px;"
                        type="button"
                        @click="handleSetLoginView('email')"
                      ></button>
                      <button
                        :class="{
                          'bg-red pointer-events-none': loginView === 'password',
                          'bg-gray-004 cursor-pointer': loginView === 'email'
                        }"
                        style="width:10px; height:3px; border-radius: 1px;"
                        type="button"
                        @click="handleEmailSubmit()"
                      ></button>
                    </div>
                  </form>
                </div>
                <div 
                  v-else-if="currView === 'forgotpassword'"
                  class="flex flex-col gap-6 justify-between"
                  :style="{
                    minHeight: minContentHeight 
                  }"
                >
                  <div class="flex flex-col gap-4">
                    <h3 class="text-24px">Forgot Password</h3>
                    <p>Enter the email address assoassociated with your account and we will send you an email with a link to reset it.</p>
                  </div>
                  <form @submit.prevent="handlefpSubmit()" class="flex flex-col gap-3">
                    <div>
                      <div class="flex flex-col gap-3">
                        <div>&nbsp;</div>
                        <div>
                          <input 
                            v-model="fpEmail"
                            type="email" 
                            class="p-3 bg-gray-001 rounded-default border-1 border-solid border-gray-003"
                            placeholder="Email"
                            required
                          >
                        </div>
                        <button 
                          class="bg-black text-white rounded-default p-3"
                          type="submit"
                        >Reset Password</button>
                      </div>
                    </div> 
                  </form>
                </div>
                <div 
                  v-else-if="currView === 'fpsent'"
                  class="flex flex-col gap-6 justify-between"
                  :style="{
                    minHeight: minContentHeight 
                  }"
                >
                  <div class="flex flex-col gap-4">
                    <h3 class="text-24px">Email Sent</h3>
                    <p>{{ fpSuccessMessage }}</p>
                    <p></p>
                  </div>
                  <div class="flex flex-col gap-3">
                    <div>
                      <div class="flex flex-col gap-3">
                        <button 
                          class="bg-black text-white rounded-default p-3"
                          type="button"
                          @click="handleSetCurrView('login')"
                        >Back to Login</button>
                      </div>
                    </div> 
                  </div>
                </div>
              </div>
            </template>
          </div>
        </section>
      </template>
    </div>
	</div>
</template>

<script setup>
import { ref, onMounted, computed, watch, nextTick, defineEmits, defineProps } from 'vue'
import store from '@/store'
import { 
  LoadingSpinner
} from '@/components/'

const emit = defineEmits([
  'auth-init',
  'view-change',
  'login-success',
  'login-fail',
  'reset-password-success',
  'reset-password-fail'
])

const props = defineProps({
  email: String,
  password: String
})

// Variables
const isLoading = ref(true)
const isError = ref(false)
const currView = ref('login')
const refErrorTitle = ref(null)
const refErrorMessage = ref(null)
const defaultErrorTitle = ref('Error')
const defaultErrorMessage = ref('An error occurred while processing your request. Please try again later or contact support if the issue persists.')
const loginView = ref('email')
const minContentHeight = '240px'
const showPassword = ref(false)
const loginEmail = ref(null)
const loginPassword = ref(null)
const fpEmail = ref(null)
const emailPlaceholder = ref('Email') 
const loginEmailEl = ref(null)
const loginPasswordEl = ref(null)
const fpSuccessMessage = ref('If an account exists for the provided email, a password reset link has been sent. Please check your inbox (and spam folder) for further instructions.')

// Computed
const regUrl = computed(() => {
  return 'https://suiteweb.atpointofcare.com/#user/login'
})

const errorTitle = computed(() => {
  return refErrorTitle.value || defaultErrorTitle.value
})

const errorMessage = computed(() => {
  return refErrorMessage.value || defaultErrorMessage.value
})

const isEmailValid = computed(() => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(loginEmail.value)
})

// Event Handler
const handleSetCurrView = (val) => {
  currView.value = val
  handleResetValues()
  emit('view-change', val)
}

const handleSetLoginView = async (val) => {
  loginView.value = val
}

const handleSetShowPassword = (val) => {
  showPassword.value = val
}

const handleEmailSubmit = async () => {
  if (currView.value !== 'login' || loginView.value !== 'email') return

  if (loginEmail.value && isEmailValid.value) {
    handleSetLoginView('password')
    await nextTick()
    loginPasswordEl.value?.focus()
  }
  else {
    const el = loginEmailEl.value
    if (!el || !el.checkValidity()) {
      el?.reportValidity()
      el?.focus()
      return
    }
  }
}

const handleLoginSubmit = async () => {
  if (loginPassword.value) {
    isLoading.value = true
    await submitUserLogin({
      email: loginEmail.value,
      password: loginPassword.value
    })
    isLoading.value = false
  }
}

const handlefpSubmit = async () => {
  if (fpEmail.value) {
    isLoading.value = true
    await submitResetPassword({
      email: fpEmail.value
    })
    isLoading.value = false
  }
}

const handleResetValues = () => {
  handleSetLoginView('email')
  loginEmail.value = null
  loginPassword.value = null
  refErrorTitle.value = null
  refErrorMessage.value = null
  isError.value = false
}

const handlTryAgainClick = () => {
  handleResetValues()
  currView.value = 'login'
}

// Functions
const submitUserLogin = async (payload) => {
  const url = process.env.VUE_APP_AUTH_API_URL
  try {
    const getToken = await store.dispatch('CRUD', {
      method: 'GET',
      url: `${ url }?email=${ payload.email }&password=${ payload.password }`
    })

    if (getToken.error) throw (getToken.error)
    else {
      emit('login-success', getToken.token)
      handleSetCurrView('login')
    }
  }
  catch (error) {
    emit('login-fail')
    handleSetCurrView(null)
    refErrorTitle.value = 'Log In Unsuccessful'
    refErrorMessage.value = error
    isError.value = true
  }
}

const submitResetPassword = async (payload) => {
  const url = process.env.VUE_APP_FORGOT_PASSWORD_API_URL
  try {
    const getToken = await store.dispatch('CRUD', {
      method: 'GET',
      url: `${ url }?email=${ payload.email }&password=${ payload.password }`
    })

    if (getToken.error) throw (getToken.error)
    else {
      emit('reset-password-success', payload.email)
      handleSetCurrView('fpsent')
    }
  }
  catch (error) {
    emit('reset-password-fail')
    handleSetCurrView(null)
    refErrorTitle.value = 'Password Reset Unsuccessful'
    refErrorMessage.value = error
    isError.value = true
  }
}

// Watchers
watch(
  () => [props.email, props.password],
  async ([newEmail, newPassword]) => {
    if (newEmail) {
      loginEmail.value = newEmail
      if (newPassword) {
        loginPassword.value = newPassword
        await nextTick()
        handleLoginSubmit()
      }
    }
  },
  { immediate: true }
)

// Life Cycle Hooks
onMounted(() => {
  isLoading.value = false
  emit('auth-init')
})
</script>

<style src="@/assets/css/tailwind.css"></style>
<style src="@/assets/css/_fontface.css"></style>
<style src="@/assets/css/_variables.css"></style>
<style src="@/assets/css/_global.css"></style>
<style src="@/assets/css/_animations.css"></style>
<style src="@/assets/css/main.css"></style>